function NodePage() {
    /**
     *
     */
    NodePage.prototype.initialize = function (console) {
        this.id = "node";
        this.console = console;

        return this;
    };

    /**
     *
     */
    NodePage.prototype.show = function () {
        var deferred = $.Deferred();

        try {
            this.extractActorsAndSensors();

            //this.initializeSpeech();

            // Update all Devices, Actors and Sensors

            this.console.connectNode();
            this.console.consoleService.pollNode(this.console.node);

            deferred.resolve();
        }
        catch (error) {
            this.console.consoleService.logError(error);

            deferred.reject(error)
        }

        return deferred.promise();
    };

    /**
     *
     */
    NodePage.prototype.extractActorsAndSensors = function () {
        this.sensors = [];
        this.actors = [];

        for (var m in this.console.node.devices) {
            for (var l in this.console.node.devices[m].sensors) {
                this.sensors.push(this.console.node.devices[m].sensors[l]);
            }

            for (var l in this.console.node.devices[m].actors) {
                this.actors.push(this.console.node.devices[m].actors[l]);
            }
        }
    };

    /**
     *
     */
    NodePage.prototype.initializeSpeech = function () {
        var context = {productions: []};

        context.productions.push({
            name: "help",
            tokens: "help",
            synophones: "held",
            action: function () {
                this.console.speech.utter("You have selected node " + this.node.label);
            }.bind(this)
        });
        context.productions.push({
            name: "Context",
            tokens: "context",
            action: function () {
                this.console.speech.utter("You have selected node " + this.node.label);
            }.bind(this)
        });

        for (var n in this.console.node.groups) {
            context.productions.push({
                name: "Group Navigation",
                tokens: this.console.node.groups[n].label,
                action: function () {
                    this.console.speech.utter("switching context to group " + this.node.groups[n].label);
                    this.console.pushGroupPage(this.console.node.groups[n]);
                }.bind(this)
            });
        }

        this.console.speech.setContext(context);
    };

    /**
     *
     */
    NodePage.prototype.leave = function () {
    };
}
